export default __webpack_public_path__ + "static/media/kumofrenz.6f15136b.webp";